import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import icon_Polygon_white from "src/assets/images/icon_Polygon_white.svg";
import icon_Cosmos_white from "src/assets/images/icon_Cosmos_white.svg";
import icon_Solana_white from "src/assets/images/icon_Solana_white.svg";
import icon_Polkadot_white from "src/assets/images/icon_Polkadot_white.svg";
import icon_Ethereum_white from "src/assets/images/icon_Ethereum_white.svg";
import icon_Oasis_white from "src/assets/images/icon_Oasis_white.svg";
import icon_Avalanche_white from "src/assets/images/icon_Avalanche_white.svg";
import icon_Near_white from "src/assets/images/icon_Near_white.svg";


const datas = [
    {
        nodeName: "Polygon",
        icon: icon_Polygon_white
    }, {
        nodeName: "Cosmos",
        icon: icon_Cosmos_white
    }, {
        nodeName: "Solana",
        icon: icon_Solana_white
    }, {
        nodeName: "Polkadot",
        icon: icon_Polkadot_white
    }, {
        nodeName: "Ethereum",
        icon: icon_Ethereum_white
    }, {
        nodeName: "Oasis",
        icon: icon_Oasis_white
    }, {
        nodeName: "Avalanche",
        icon: icon_Avalanche_white
    },  {
        nodeName: "Near",
        icon: icon_Near_white
    }
]

export const PoSProjects = (props: {}) => {

    return (
        <Box p="50px 40px 141px">
            <Box display="flex" alignItems="center" justifyContent="center">

                <Typography fontSize="30px" variant="bold" color="#FFFFFF">
                    PoS Projects
                </Typography>
            </Box>
            <Box display="flex" alignItems="center" justifyContent="center">
                <Typography fontSize="16px" color="secondary" mt="15px">
                    Total 8 blockchain stakeshots that cover most of the PoS Chains
                </Typography>
            </Box>

            <Box
                mt="60px"
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(8, 100px)",
                    rowGap: "50px",
                    justifyContent: "space-between",
                }}
            >
                {datas.map((item) => {
                    return <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                        <img src={item.icon} />
                        <Typography fontSize="18px" variant="bold" color="#FFFFFF" mt="15px">
                            {item.nodeName}
                        </Typography>
                    </Box>
                })}
            </Box>

        </Box>
    );
};
